/**
 * Says plainly whether a demo was built on stage or production: a build's environment is
 * the sf-api NODE_ENV it was started on ("staging" | "production").
 */
import { Tag } from 'antd';
import { environmentLabel, isProduction } from '../../../config/env';

export const EnvironmentTag: React.FC<{ env: string | null | undefined }> = ({ env }) => (
  <Tag color={isProduction(env) ? 'red' : 'blue'}>{environmentLabel(env)}</Tag>
);
